<!--共享超时支付-->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "shareTimeoutValue": "10.00",
                "shareTimeoutStartTime": "2018-04-11 09:00:00",
                "shareTimeoutEndTime": "2018-04-11 10:00:00",
                "billCode": "12312312312313123",
                "parkingCode": "180410135558832886170666",
                "payDate": "2018-04-11 10:01:00",
                "payOrigin": "9",
                "payOriginRemark": "线上支付",
                "paymentMode": "12",
                "paymentModeRemark": "第三方余额",
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台进行共享超时支付",
                t_url: this.commonUrls.test+"shareOvertimePay",
                p_url: this.commonUrls.prod+"shareOvertimePay",
                precondition: "VEMS 2.13及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'shareTimeoutValue', info2: '是', info3: 'decimal', info4: '超时金额;注：超时支付金额不计算在主字段actPayCharge中' },
                        { info1: 'shareTimeoutStartTime', info2: '是', info3: 'String', info4: '超时开始时间' },
                        { info1: 'shareTimeoutEndTime', info2: '是', info3: 'String', info4: '超时结束时间' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '共享订单号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车场流水号' },
                        { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间' },
                        { info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                        { info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'paymentModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ydtBillCode', info2: '是', info3: 'String', info4: '智慧停车账单编号' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/shareBooking/shareOvertimePay.vue